import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '../../../components/Button';
import messages from '../../messages';
import { AdditionalExpensesListItem } from './AdditionalExpensesListItem';

export class AdditionalExpensesList extends React.Component {
  componentDidMount() {
    if (this.props.data.length <= 0) {
      this.addItem();
    }
  }

  onRemove = (id) => {
    let arrayData = this.props.data;

    // find and remove item from data by id
    arrayData = arrayData.filter((t) => t.id !== id);

    this.onChange(arrayData);
  };

  onItemChanged = (itemChanged) => {
    const item = this.props.data.filter((t) => t.id === itemChanged.id)[0];

    if (item) {
      // find and update item by id
      const newData = this.props.data.map(
        (el) => el.id === itemChanged.id ? Object.assign({}, el, itemChanged) : el
      );

      this.onChange(newData);
    }
  };

  onChange = (data) => {
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  };

  addItem = () => {
    const arrayData = this.props.data;

    arrayData.push({
      id: new Date().getTime().toString(),
      dateOfExpense: '',
      description: '',
      supplier: '',
      amountPaid: '',
      amountPaidCurrency: '',
    });

    this.onChange(arrayData);
  };

  render() {
    const { disabled, data } = this.props;
    const removable = data.length > 1;

    return (
      <div className="w-full">
        {data.map((item, index) => (<AdditionalExpensesListItem
          {...this.props}
          index={index}
          key={item.id}
          item={item}
          onChange={this.onItemChanged}
          onRemove={this.onRemove}
          disabled={disabled}
          removable={removable}
        />))}
        {!disabled &&
        <div className="row">
          <div className="col-auto">
            <Button onClick={this.addItem}>
              <FormattedMessage {...messages.addAdditionalExpense} />
            </Button>
          </div>
        </div>}
      </div>
    );
  }
}

AdditionalExpensesList.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step10/components/AdditionalExpenses/index.js